import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Les contenus changent rarement : on évite les refetch à chaque navigation.
        staleTime: 5 * 60 * 1000,
        // Conservé assez longtemps pour alimenter le cache persistant (24 h).
        gcTime: 24 * 60 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Fondu discret entre les pages via l'API native View Transitions
    // (désactivé automatiquement si prefers-reduced-motion est actif, cf. styles.css).
    defaultViewTransition: true,
  });

  return router;
};
